import { openHelperPage } from '@com/utils/helper'

export default {
  methods: {
    toHelperPage() {
      const state = this.$store.state
      const isPs =
        this.$route.query.project_type === 'playsmart' ||
        this.$route.path.indexOf('workbench') > -1

      const getCurProduce = () => {
        if (isPs) {
          return 'ps'
        } else if (state.pt && state.pt.isGMaker) {
          return 'gm'
        }
        return 'dm'
      }
      openHelperPage(getCurProduce())
    },
  },
}
